export const accountPasswordForm = 'accountPassword';

export const accountInfoForm = 'accountInfo';

export const newPasswordField = 'newPassword';
export const confirmationField = 'confirmation';
